
import Vue from "vue";
import VueRouter from "vue-router";
import { store } from '../store/store.js'; // eslint-disable-line no-unused-vars

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Dashboard",
    meta: {
      requiresUserAuth: true,
      title: 'SCHUBERTH INTERN'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "dash" */ "../views/Dashboard.vue")
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      title: 'SCHUBERTH INTERN - Login'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue")
  },
  {
    path: '*',
    redirect: '/'
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

/*
//redirect to login page if not logged in and trying to access protected resource
router.beforeEach((to, from, next) => {
  // to and from are both route objects. must call `next`.
  const pubPages = ['/login'];
  const authRequired = !pubPages.includes(to.path);
  const loggedIn = localStorage.getItem('shjwt');

  if(authRequired && !loggedIn){
      return next('/login');
  }

  next();
})
*/

//ENABLE THIS IF LOGIN IS REQUIRED!

router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.requiresUserAuth)) {
    //if there is no token or expired, push without error message
    if (store.getters.tokenNotGivenOrExpired()) { next('/login'); return }

    if (store.getters.isLoggedInAsUser || store.getters.isLoggedInAsAdmin) {
      next()
      return
    }
    next('/login')
    throw new Error('You are not allowed to access the requested Resource');
    //store.commit('showError','You are not allowed to access the requested Resource');
    //return;
  }
  /*else if(to.matched.some(record => record.meta.requiresAdminAuth)){
    //if there is no token or expired, push without error message
    if(store.getters.tokenNotGivenOrExpired){ next('/login'); return}

    if (store.getters.isLoggedInAsAdmin) {
      next()
      return
    }
    next('/login')
    throw new Error('You are not allowed to access the requested Resource');
    //store.commit('showError','You are not allowed to access the requested Resource');
    //return;
  }*/ else {
    next();
  }

})

router.onError((err) => { store.dispatch('showError', err.message); })

export default router;
